import { render } from "./UserIcon.vue?vue&type=template&id=39b8609f"
const script = {}

import exportComponent from "/container/application/releases/20260729235012/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__